import { render } from "./MatchingProductionOrderModal.vue?vue&type=template&id=20b27b38&scoped=true&ts=true&lang=pug"
import script from "./MatchingProductionOrderModal.vue?vue&type=script&lang=ts"
export * from "./MatchingProductionOrderModal.vue?vue&type=script&lang=ts"

import "./MatchingProductionOrderModal.vue?vue&type=style&index=0&id=20b27b38&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b27b38"]])

export default __exports__